import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { DataTable } from "../components/DataTable";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useSales } from "../data/platform-data";
import { useTenantRuntime } from "../config/TenantRuntime";

export function SalesPage() {
  const { tenant } = useTenantRuntime();
  const isFlow = tenant.product.commercialProductCode === "EVA_FLOW";
  const query = useSales();
  if (isFlow) {
    return (
      <Card
        title="Vendas por produto"
        description="Produtos próprios e de parceiros são oferecidos por módulos independentes."
      >
        <EmptyState
          title="Nenhuma venda registrada neste ambiente"
          description="A habilitação comercial, os preços e os contratos de cada parceiro devem ser configurados antes de vender."
        />
        <Link className="text-link" to="/produtos">
          Ver módulos disponíveis
        </Link>
      </Card>
    );
  }
  return (
    <Card
      title="Funil de contratação"
      description={
        isFlow
          ? "Acompanhe oportunidades de produtos próprios e de parceiros por módulo comercial."
          : "O Cruzeiro Life conduz a contratação; a integração com a EVA será ativada conforme o contrato do cliente."
      }
      action={
        !isFlow && (
          <Link to="/onboarding">
            <Button>
              <Plus size={16} /> Nova venda
            </Button>
          </Link>
        )
      }
    >
      {query.isLoading && <Skeleton className="table-skeleton" />}
      {query.error && (
        <EmptyState title="Falha ao carregar vendas" description={query.error.message} />
      )}
      {!query.isLoading && !query.error && (
        <DataTable
          rows={query.data ?? []}
          getKey={(sale) => sale.id}
          columns={[
            { key: "created", header: "Criada em", render: (sale) => sale.createdAt },
            { key: "customer", header: "Cliente", render: (sale) => sale.customer },
            { key: "offer", header: "Oferta", render: (sale) => sale.offer },
            { key: "seller", header: "Vendedor", render: (sale) => sale.seller },
            { key: "source", header: "Origem", render: (sale) => sale.source },
            {
              key: "status",
              header: "Status",
              render: (sale) => <Badge tone="info">{sale.status}</Badge>,
            },
            { key: "amount", header: "Valor", render: (sale) => sale.amount },
          ]}
        />
      )}
    </Card>
  );
}
